<template>
  <tbody v-if="fillManualFlag">
    <tr v-for="(item, index) in data" :key="index">
      <template>
        <td class="switch-icon" :class="item.loadRow ? '' : 'bg-white px-5/2'" :style="item.status === 200 ? 'background: #E7EEFB !important; pointer-events: none;': ''">
          <span>{{ index+1 }}</span>
          <feather-icon @click="deleteRow(index)" icon="Trash2Icon" svgClasses="w-5 h-5" class="self-center text-red"/>
        </td>
        <td>
          <input class="h-full" @paste.prevent="fillData($event, index, 'full_name')" :disabled="item.status === 200" :style="item.status === 200 ? 'background: #E7EEFB;': ''" 
            v-model="item.customer.full_name" type="text" :class="(validateErrorContainCustomerError(item) && item.errors.error.customer.full_name) ? 'invalid-input' : ''" >
        </td>
        <td>
          <input class="h-full" @paste.prevent="fillData($event, index, 'phone')" :disabled="item.status === 200" :style="item.status === 200 ? 'background: #E7EEFB;': ''" :name="`phone-number-${index}`"
            v-validate="{regex: /(^01[0,1,2,5]\d{8}$|^\u0660\u0661[\u0660,\u0661,\u0662,\u0665][\u0660-\u0669]{8}$)/ }"
            v-model="item.customer.phone" type="text" :class="(validateErrorContainCustomerError(item) && item.errors.error.customer.phone) || ((item.customer.phone === '' || item.customer.phone === null) && item.customer.full_name !== '') || errors.has(`phone-number-${index}`) ? 'invalid-input' : ''">
        </td>
        <td>
          <input class="h-full" @paste.prevent="fillData($event, index, 'line_1')" :disabled="item.status === 200" :style="item.status === 200 ? 'background: #E7EEFB;': ''"
            v-model="item.customer.address.line_1" @change="autoZoneFlag ? autoZone(item) : ''" type="text" :class="(validateErrorContainCustomerError(item) && item.errors.error.customer.address && item.errors.error.customer.address.line_1) ||  ((item.customer.address.line_1 === '' || item.customer.address.line_1 === null) && item.customer.full_name !== '') ? 'invalid-input' : ''">
        </td>
        <!-- <td>
          <template v-if="item.loadRow">
            <div class="animated-input">
              <div class="line rounded-lg h-4"></div>
            </div>
          </template>
          <div class="flex justify-between h-full gap-2" v-else>
            <shipblu-select v-on:input="fireMixpanelEvent()" :style="item.status === 200 ? 'background: #E7EEFB; pointer-events: none;': 'background: white;'" class="w-full upload-order-zone" :key="updatedZonesKey" :localize="true" :options="zones" optionLabel="name" inputId="input-zone" 
              :defaultValue="item.customer.address" :labelPlaceholder="$t('Zone')" name="zone" type="high_level" @selectedOptions="selectZoneOptions($event, index)"
              :class="(validateErrorContainCustomerError(item) && item.errors.error.customer.address && item.errors.error.customer.address.zone) || (item.customer.address.zone && item.customer.address.zone.id && item.customer.address.zone.id === 284) || ((item.customer.address.zone === '' || item.customer.address.zone === null) && item.customer.full_name !== '') ? 'invalid-input' : ''" />
          </div>
        </td> -->
        <td v-if="!fulfillment">
          <v-select class="h-full order-type" v-on:input="checkOrderType(item.type)" :style="item.status === 200 ? 'background: #E7EEFB;pointer-events: none;': ''"
            v-model="item.type" name="order type" :options="types"/>
        </td>
        <td v-if="!fulfillment">
          <div class="input-number h-full">
            <input class="text-center h-full" :class="errors.has(`number-of-packages-${index}`) ? 'invalid-input' : ''" v-validate="'numeric|min_value:0|max_value:4'" :name="`number-of-packages-${index}`" :disabled="item.status === 200" :style="item.status === 200 ? 'background: #E7EEFB;': ''"
              v-model="item.number_of_packages" type="number">
          </div>
        </td>
        <td>
          <input class="h-full text-center" @paste.prevent="fillData($event, index, 'cash_amount')" :disabled="item.status === 200 || isTryAndBuyOrder(item)" :style="item.status === 200 ? 'background: #E7EEFB;': isTryAndBuyOrder(item) ? 'background: #EFEDED;' : ''" 
            v-validate="'decimal|min_value:0'" :name="`cash-amount-${index}`"
            :class="errors.has(`cash-amount-${index}`) ? 'invalid-input' : ''"
            v-model.number="item.cash_amount" type="text">
        </td>
        <td>
          <div class="checkbox-input" :style="item.status === 200 ? 'background: #E7EEFB;': ''">
            <vs-checkbox :disabled="item.status === 200" v-model="item.is_customer_allowed_to_open_packages" />
          </div>
        </td>
        <td>
          <div class="checkbox-input" :style="item.status === 200 ? 'background: #E7EEFB;': ''">
            <vs-checkbox :disabled="item.status === 200" v-model="item.fragile" />
          </div>
        </td>
        <td v-if="fulfillment">
          <input class="h-full" disabled :style="item.status === 200 ? 'background: #E7EEFB;': 'background: #EFEDED;'" 
            v-model="item.skus" type="text" :class="(item.errors && item.errors.error && item.errors.error.products) ? 'invalid-input' : ''" >
        </td>
        <td v-if="fulfillment">
          <input class="h-full" disabled :style="item.status === 200 ? 'background: #E7EEFB;': 'background: #EFEDED;'" 
            v-model="item.quantity" type="text" :class="(validateErrorContainCustomerError(item) && item.errors.error.quantity) ? 'invalid-input' : ''" >
        </td>
        <td v-for="(extraCol, extraColIndex) in extraCols" :key="extraColIndex">
          <v-select class="h-full order-type" :style="item.status === 200 ? 'background: #E7EEFB;pointer-events: none;': ''" v-if="extraCol.value === 'pickup_point'" name="pickup point" v-model="item.pickup_point" :options="pickupPoints" label="fullAddress"/>
          <div v-else-if="extraCol.value === 'is_counter_dropoff'" :style="item.status === 200 ? 'background: #E7EEFB;pointer-events: none;': ''" class="checkbox-input">
            <vs-checkbox :disabled="item.status === 200" v-model="item[extraCol.value]" />
          </div>
          <input v-validate="item.customer.full_name !== '' && item.type === 'Return' ? 'required' : ''" :name="`notes-${index}`" v-else-if="extraCol.value === 'order_notes'" v-model="item[extraCol.value]" class="h-full" type="text" :disabled="item.status === 200" :style="item.status === 200 ? 'background: #E7EEFB;': ''"
            :class="item.type === 'Return' && item.customer.full_name !== null && item['order_notes'] === '' ? 'invalid-input' : ''">
          <input v-else @paste.prevent="fillData($event, index, extraCol.value)" v-model="item[extraCol.value]" class="h-full" type="text" :disabled="isDisabledExtraCol(item, extraCol)" :style="item.status === 200 ? 'background: #E7EEFB;': isReadOnlyExtraCol(extraCol) ? 'background: #EFEDED;' : ''"
            :class="[validateErrorContainCustomerError(item) && (item.errors.error[extraCol.value] || item.errors.error.customer[extraCol.value] || (item.errors.error.customer.address && item.errors.error.customer.address[extraCol.value])) ? 'invalid-input' : '', extraCol.name === 'Products Declared Value' ? 'text-center' : '']">
        </td>
        <td>
          <div class="h-full" type="text" :disabled="item.status === 200" :style="item.status === 200 ? 'background: #E7EEFB;': ''"></div>
        </td>
      </template>
    </tr>
  </tbody>
</template>

<script>
import vSelect from 'vue-select'
import { sendRequest } from '../../../http/axios/requestHelper'
import i18nData from '../../../i18n/i18nData'
import readXlsxFile from 'read-excel-file'
import common from '../../../assets/utils/common'
import staticZones from '../../../assets/utils/geo.json'

export default {
  props: [
    'data', 'extraCols', 'sendOrdersFlag', 'uploadFileFlag', 'originFile', 'merchant', 'userMerchant', 'fulfillment',
    'fillManualFlag', 'deletedFile', 'fileDetails', 'rows', 'replacedFile', 'autoZoneFlag', 'AWBIds', 'optionalCols', 'fillManualPressed'
  ],
  data () {
    return {
      zones: staticZones,
      firstSend: true,
      types: ['Delivery', 'Return', 'Exchange', 'Cash Collection'],
      typesDic: {'Delivery': 'delivery-orders', 'Return': 'returns', 'Exchange':  'exchanges', 'Cash Collection': 'cash-collections'},
      governorates: [],
      isReplace: false,
      subscriptionId: '',
      activeIndex: '',
      updatedZonesKey: 0,
      releaseVersion: process.env.VUE_APP_RELEASE_VERSION
    }
  },
  watch: {
    data (val) {
      if (val) {
        val.forEach(item => {
          this.syncOptionalColsFromOrder(item)
        })
      }
    },
    uploadFileFlag () {
      this.uploadFile(this.originFile)
    },
    deletedFile () {
      if (this.deletedFile !== '') this.removeItemsFromData(this.deletedFile)
    },
    sendOrdersFlag (val) {
      if (val === true) {
        this.sendOrders()
      }
    },
    'autoZoneFlag' (val) {
      if (val === true) {
        const ordersWithAddress = this.data.filter(item => item.customer.address.line_1)
        ordersWithAddress.forEach(item => {
          this.autoZone(item)
        })
      }
    },
    userMerchant () {
      this.loadPickupPoints()
    }
  },
  methods: {
    selectZoneOptions (value, index) {
      this.data[index].customer.address.zone = value[0]
    },
    checkOrderType (type) {
      if (type === 'Return') {
        this.markOptionalColumn('is_counter_dropoff')
      }
    },
    fillData (event, index, type) {
      const fullData = event.clipboardData.getData('text')
      const rawRows = fullData.split('\n')
      const pasteData = []
      let splitCols = {}
      rawRows.forEach((rawRow) => {
        const values = rawRow.split('\t')
        let [name, phone, line_1] = ['', '', '']
        switch (type) {
        case 'full_name':
          [name, phone, line_1] = values
          splitCols = {name, phone, line_1}
          break
        case 'phone':
          [phone, line_1] = values
          splitCols = {phone, line_1}
          break
        case 'line_1':
          [line_1] = values
          splitCols = {line_1}
          break
        default:
          splitCols = {[type]: values}
        }
        pasteData.push(splitCols)
      })
      const extraRowsNumber = this.data.length < (pasteData.length + index + 1) ? (pasteData.length + index) - this.data.length : 0
      this.$emit('addExtraRows', extraRowsNumber)
      switch (type) {
      case 'full_name':
        for (let i = 0; i < pasteData.length; i++) {
          this.data[index].customer.full_name = pasteData[i].name
          if (pasteData[i].phone) this.data[index].customer.phone = pasteData[i].phone
          if (pasteData[i].line_1) {
            this.data[index].customer.address.line_1 = pasteData[i].line_1
            if (this.autoZoneFlag) this.autoZone(this.data[index])
          }
          index++
        }
        break
      case 'phone':
        for (let i = 0; i < pasteData.length; i++) {
          this.data[index].customer.phone = pasteData[i].phone
          if (pasteData[i].line_1) {
            this.data[index].customer.address.line_1 = pasteData[i].line_1
            if (this.autoZoneFlag) this.autoZone(this.data[index])
          }
          index++
        }
        break
      case 'line_1':
        for (let i = 0; i < pasteData.length; i++) {
          this.data[index].customer.address.line_1 = pasteData[i].line_1
          if (this.autoZoneFlag) this.autoZone(this.data[index])
          index++
        }
        break
      default:
        for (let i = 0; i < pasteData.length; i++) {
          this.data[index][type] = pasteData[i][type]
          index++
        }
        break
      }
    },
    deleteRow (rowIndex) {
      this.activeIndex = rowIndex
      this.$vs.dialog({
        color: 'danger',
        title: i18nData[this.$i18n.locale]['Confirm'],
        text: i18nData[this.$i18n.locale]['Are you sure to remove this row?'],
        accept: this.confirmDelete
      })
    },
    confirmDelete () {
      this.data.splice(this.activeIndex, 1)
      this.$nextTick(() => {
        this.updatedZonesKey++
      })
    },
    validateErrorContainCustomerError (order) {
      if (order.errors && order.errors.error && order.errors.error.customer) {
        return true 
      }
    },
    isReadOnlyExtraCol (extraCol) {
      return (this.fulfillment && extraCol.value === 'merchant_order_reference') || ['product_sku', 'requested_quantity'].includes(extraCol.value)
    },
    isDisabledExtraCol (item, extraCol) {
      return item.status === 200 || this.isReadOnlyExtraCol(extraCol)
    },
    uploadFile (file) {
      if (!this.isExcel(file)) {
        this.$vs.notify({
          color: 'warning',
          title: i18nData[this.$i18n.locale]['Warning'],
          text: 'Only supports upload .xlsx, .xls, .csv suffix files',
          position: 'top-center'
        })
        return false
      }
      this.myProgress = setInterval(() => {
        this.fileDetails.forEach(item => {
          if (item && item.data && item.data.name && file.name && item.data.name === file.name) {
            item.progress = item.progress === 100 ? item.progress : item.progress += 20
          }
        })
      }, 500)
      this.data.forEach((item, index) => {
        if (item.customer.full_name !== '') this.lastFilledRow = index
      })
      let oldDataExistLength = 0
      for (let i = 0; this.data.length > i; i++) {
        if (this.data[i].customer.full_name !== '') oldDataExistLength = i
      }
      const options = { sheet: 'Order Details' }
      oldDataExistLength = (oldDataExistLength === 0 && this.data[0] && this.data[0].customer.full_name === '') || this.data[0] === undefined ? 0 : oldDataExistLength + 1
      readXlsxFile(file, options).then((rows) => {
        if ((rows[0][0] === 'Full Name*' && rows[0][9] === 'Shipment Type' && rows[0][12] === 'Discount Code') || (this.fulfillment && rows[0][0] === 'Order Reference')) {
          rows = rows.slice(1)
          if (!this.fillManualPressed) {
            for (let index = 0; index < rows.length; index++) {
              this.data.push({
                fulfillment_order_reference: '',
                skus: '',
                quantity: '',
                pickup_point: '',
                errors: {},
                fileName: '',
                status: 0,
                customer: {
                  full_name: '',
                  phone: '',
                  address: {
                    line_1: '',
                    // zone: ''
                    zone: 284
                  }
                },
                secondary_phone: '',
                type: '',
                number_of_packages: '',
                cash_amount: '',
                is_customer_allowed_to_open_packages: false,
                fragile: false,
                loadRow: false,
                order_notes: '',
                merchant_order_reference: '',
                is_counter_dropoff: false,
                line_2: '',
                declared_value: '',
                discount_code: '',
                dba: '',
                shipping_fees: '',
                product_sku: '',
                requested_quantity: ''
              })
            }
          } else {
            const extraRow = rows.length - (this.data.length - oldDataExistLength) 
            for (let index = 0; index < extraRow; index++) {
              this.data.push({
                pickup_point: '',
                errors: {},
                fileName: '',
                status: 0,
                customer: {
                  full_name: '',
                  phone: '',
                  address: {
                    line_1: '',
                    // zone: ''
                    zone: 284
                  }
                },
                secondary_phone: '',
                type: '',
                number_of_packages: '',
                cash_amount: '',
                is_customer_allowed_to_open_packages: false,
                fragile: false,
                loadRow: false,
                order_notes: '',
                merchant_order_reference: '',
                is_counter_dropoff: false,
                line_2: '',
                declared_value: '',
                discount_code: '',
                dba: '',
                shipping_fees: '',
                product_sku: '',
                requested_quantity: ''
              })
            }
          }
          rows.forEach((row, index) => {
            this.data.forEach(() => {
              if (this.fulfillment) {
                this.data[index + oldDataExistLength].merchant_order_reference = row ? row[0] : ''
                this.data[index + oldDataExistLength].customer.full_name = row ? row[1] : ''
                this.data[index + oldDataExistLength].customer.phone = row ? row[2] : ''
                this.data[index + oldDataExistLength].secondary_phone = row ? row[3] : ''
                this.data[index + oldDataExistLength].customer.address.line_1 = row ? row[4] : ''
                this.data[index + oldDataExistLength].cash_amount = row ? row[5] : ''
                this.data[index + oldDataExistLength].order_notes = row ? row[6] : ''
                this.data[index + oldDataExistLength].fragile = row ? row[7] === 'Yes' ? true : row[7] === 'No' ? false : '' : false
                this.data[index + oldDataExistLength].is_customer_allowed_to_open_packages = row ? row[8] === 'Yes' ? true : row[8] === 'No' ? false : '' : false
                this.data[index + oldDataExistLength].skus = row ? row[9] : ''
                this.data[index + oldDataExistLength].quantity = row ? row[10] : ''
                this.data[index + oldDataExistLength].fileName = this.originFile.name
              } else {
                this.data[index + oldDataExistLength].customer.full_name = row ? row[0] : ''
                this.data[index + oldDataExistLength].customer.phone = row ? row[1] : ''
                this.data[index + oldDataExistLength].customer.address.line_1 = row ? row[2] : ''
                this.data[index + oldDataExistLength].secondary_phone = row ? row[3] : ''
                this.data[index + oldDataExistLength].cash_amount = row ? row[4] : 0
                this.data[index + oldDataExistLength].declared_value = row ? row[5] : 0
                this.data[index + oldDataExistLength].order_notes = row ? row[6] : ''
                this.data[index + oldDataExistLength].merchant_order_reference = row ? row[7] : ''
                this.data[index + oldDataExistLength].number_of_packages = row ? row[8] === null ?  1 : row[8] : 1
                this.data[index + oldDataExistLength].type = row ? row[9] === null ? this.types[0] : row[9] : this.types[0]
                this.data[index + oldDataExistLength].is_customer_allowed_to_open_packages = row ? row[10] === 'Y' ? true : row[10] === 'N' ? false : '' : false
                this.data[index + oldDataExistLength].is_counter_dropoff = row ? row[11] === 'Y' ? true : row[11] === 'N' ? false : '' : false
                this.data[index + oldDataExistLength].discount_code = row ? row[12] : ''
                this.data[index + oldDataExistLength].dba = row ? row[13] : ''
                this.data[index + oldDataExistLength].shipping_fees = row ? row[14] : ''
                this.data[index + oldDataExistLength].product_sku = row ? row[15] : ''
                this.data[index + oldDataExistLength].requested_quantity = row ? row[16] : ''
                this.syncBuyAndTryProductColumns(this.data[index + oldDataExistLength])
                if (this.isTryAndBuyOrder(this.data[index + oldDataExistLength])) this.data[index + oldDataExistLength].cash_amount = 0
                this.data[index + oldDataExistLength].fileName = this.originFile.name
              }
            })
            const uploadedOrder = this.data[index + oldDataExistLength]
            this.syncOptionalColsFromOrder(uploadedOrder)
            if (this.autoZoneFlag) this.autoZone(uploadedOrder)
            if (uploadedOrder.type === 'Return') {
              this.markOptionalColumn('is_counter_dropoff')
            }
          })
          if (this.replacedFile) {
            this.deletedFile = this.replacedFile.data.name
            for (let i = this.fileDetails.length - 1; i >= 0; --i) {
              if (this.fileDetails[i].data.name === this.replacedFile.data.name) {
                this.fileDetails.splice(i, 1)
              }
            }
            this.isReplace = true
            this.removeItemsFromData(this.deletedFile)
          }
        } else {
          this.$vs.notify({
            color:'danger',
            title:i18nData[this.$i18n.locale]['Failed'],
            text:i18nData[this.$i18n.locale]['Wrong File!'],
            position: 'top-center'
          })
          this.$emit('deleteFile')
        }
      }).catch(() => {
        this.$vs.notify({
          color:'danger',
          title:i18nData[this.$i18n.locale]['Failed'],
          text:i18nData[this.$i18n.locale]['Wrong File!'],
          position: 'top-center'
        })
        this.$emit('deleteFile')
      })
    },
    fireMixpanelEvent () {
      if (this.autoZoneFlag === true) {
        if (this.releaseVersion !== 'staging') {
          this.$mixpanel.track('UPLOAD_V2_AUTOZONING_CHANGE_ZONE', {
            merchant_name: this.merchant.name,
            merchant_email: this.userMerchant.email,
            source: /(android)/i.test(navigator.userAgent)
          })
        }
      }
    },
    removeItemsFromData () {
      const fileRowsCount = this.data.filter(item => item.fileName === this.deletedFile).length
      let indexSplice = 0
      for (let index = 0; index < this.data.length; index++) {
        if (this.data[index].fileName === this.deletedFile) {
          indexSplice = index
          break
        }
      }
      if (this.fillManualPressed && !this.isReplace) for (let index = 0; index < fileRowsCount; index++) {
        this.data.push({
          pickup_point: '',
          errors: {},
          fileName: '',
          status: 0,
          customer: {
            full_name: '',
            phone: '',
            address: {
              line_1: '',
              // zone: ''
              zone: 284  
            }
          },
          secondary_phone: '',
          type: '',
          number_of_packages: '',
          cash_amount: '',
          is_customer_allowed_to_open_packages: false,
          fragile: false,
          loadRow: false,
          order_notes: '',
          merchant_order_reference: '',
          is_counter_dropoff: false,
          line_2: '',
          declared_value: '',
          discount_code: '',
          dba: '',
          shipping_fees: '',
          product_sku: '',
          requested_quantity: ''
        })
      }
      this.data = this.data.splice(indexSplice, fileRowsCount)
      this.isReplace = false
      this.$emit('deletedFile', '')
      this.$emit('replacedFile', '')
    },
    isExcel (file) {
      return /\.(xlsx|xls|csv)$/.test(file.name)
    },
    autoZone (order) {
      const address = {
        full_address: order.customer.address.line_1
      }
      if (address && address.full_address && address.full_address.length > 10) {
        order.loadRow = true
        sendRequest(true, false, this, 'api/v2/gpt/autozoner/', 'post', address, true,
          (response) => {
            order.customer.address = response.data
            order.line_2 = response.data.line_2
            order.customer.address.auto_zoned = response.data.autozoned
            if (order.line_2 !== '.' && order.line_2 !== 'N/A' && order.line_2 !== ' ') {
              this.markOptionalColumn('line_2')
            } 
            this.updatedZonesKey++
            order.loadRow = false
          }, () => {
            order.loadRow = false
          }
        )
      }
    },
    loadMerchant () {
      sendRequest(true, false, this, `api/v1/users/merchants/${this.$store.state.AppActiveUser.uid}/`, 'get', null, true,
        (response) => {
          localStorage.setItem('userMerchant', JSON.stringify(response.data))
          this.loadMerchantData(response.data)
        }
      )
    },
    loadMerchantData (merchant) {
      sendRequest(true, false, this, `api/v1/merchants/${merchant.merchant}/`, 'get', null, true,
        (response) => {
          localStorage.setItem('merchant', JSON.stringify(response.data))
          this.subscriptionId = typeof response.data.subscription === 'object' ? response.data.subscription.id : response.data.subscription
        }
      )
    },
    loadPickupPoints () {
      sendRequest(true, false, this, `api/v1/merchants/${this.userMerchant.merchant}/pickup-points/?limit=60`, 'get', null, true, 
        (response) => {
          this.pickupPoints = response.data.results
          this.pickupPoints.forEach(element => {
            element.fullAddress = `${`${element.address.line_1  } ${  element.address.line_2} `}${i18nData[this.$i18n.locale][element.address.zone.name] ? i18nData[this.$i18n.locale][element.address.zone.name] : element.address.zone.name}` 
          })
        }
      )
    },
    getBuyAndTryProducts (orderData) {
      const skuValues = String(orderData.product_sku || '')
        .split(',')
        .map(value => value.trim())
        .filter(value => value !== '')
      const quantityValues = String(orderData.requested_quantity || '')
        .split(',')
        .map(value => Number(value.trim()))

      const productsBySku = new Map()
      skuValues.forEach((sku, index) => {
        const requestedQuantity = quantityValues[index] > 0 ? quantityValues[index] : 1
        if (productsBySku.has(sku)) {
          productsBySku.get(sku).requested_quantity += requestedQuantity
        } else {
          productsBySku.set(sku, {
            product_sku: sku,
            requested_quantity: requestedQuantity
          })
        }
      })

      return Array.from(productsBySku.values())
    },
    syncBuyAndTryProductColumns (orderData) {
      const buyAndTryProducts = this.getBuyAndTryProducts(orderData)
      orderData.product_sku = buyAndTryProducts.map(item => item.product_sku).join(', ')
      orderData.requested_quantity = buyAndTryProducts.map(item => item.requested_quantity).join(', ')
    },
    isTryAndBuyOrder (orderData) {
      return this.getBuyAndTryProducts(orderData).length > 0
    },
    hasOptionalColumnValue (value) {
      if (typeof value === 'boolean') return value
      if (Array.isArray(value)) return value.length > 0
      if (value && typeof value === 'object') return Object.keys(value).length > 0
      return value !== '' && value !== null && value !== undefined
    },
    markOptionalColumn (value) {
      const optionalCol = this.optionalCols.find(item => item.value === value)
      if (optionalCol && !optionalCol.checked) {
        this.$set(optionalCol, 'checked', true)
      }
    },
    syncOptionalColsFromOrder (orderData) {
      this.optionalCols.forEach(optionalCol => {
        if (this.hasOptionalColumnValue(orderData[optionalCol.value])) {
          this.markOptionalColumn(optionalCol.value)
        }
      })
    },
    sendOrders () {
      const ordersWithNames = this.data.filter(item => item.customer.full_name !== '')
      const ordersWithData = this.data.filter(item => item.customer.full_name !== '' && item.customer.address.line_1 !== '' && /(^01[0,1,2,5]\d{8}$|^\u0660\u0661[\u0660,\u0661,\u0662,\u0665][\u0660-\u0669]{8}$)/.test(item.customer.phone))
      // && item.customer.address.zone && item.customer.address.zone.id !== 284
      this.$validator.validateAll().then(result => {
        if (result && ordersWithNames.length === ordersWithData.length) {
          const promises = []
          this.data = this.data.sort(function (row, secondRow) { return secondRow.status - row.status })
          if (!this.firstSend) {
            for (let index = 0; index < this.data.length; index++) {
              const shiftError = this.data[index]
              if (shiftError.customer.full_name && shiftError.status === 0) {
                this.data.splice(index, 1)
                this.data.unshift(shiftError)
              }
            }
          }
          this.firstSend = false
          for (let index = 0; index < this.data.length; index++) {
            const order = this.data[index]
            if (order.customer.full_name && order.status !== 200) {
              promises.push(this.sendOrderToShipBluWithPromise(order))
            }
          }
          Promise.allSettled(promises)
            .then((results) => {
              results.forEach((item, index) => {
                this.data[index].status = item.status === 'rejected' ? 400 : item.status === 'fulfilled' ? 200 : 200
                this.data[index].errors = item.reason
              })
              this.$emit('data', this.data)
              this.data = this.data.sort(function (row, secondRow) { return secondRow.status - row.status })
            })
            .catch(() => {
            })
        }
      })
    },
    sendOrderToShipBluWithPromise (orderData) {
      orderData.loadRow = true
      return new Promise(async (resolve, reject) => {
        try {
          let orderBody = {}
          if (this.fulfillment) {
            const skuValues = String(orderData.skus || '')
              .split(',')
              .map(value => value.trim())
              .filter(value => value !== '')
            const quantityValues = String(orderData.quantity || '')
              .split(',')
              .map(value => value.trim())
              .filter(value => value !== '')
            const productsFromSkuQuantity = skuValues.map((sku, index) => {
              const quantityRaw = quantityValues[index]
              const quantity = Number.isFinite(Number(quantityRaw)) && Number(quantityRaw) > 0 ? Number(quantityRaw) : 1
              return {
                sku,
                quantity
              }
            })
            orderBody = {
              merchant_order_reference: orderData.merchant_order_reference ? orderData.merchant_order_reference : '',
              notes: orderData.order_notes === null ? '' : orderData.order_notes,
              delivery: {
                packages: [
                  {
                    package_size: 2
                  }
                ],
                cash_amount: Number(orderData.cash_amount),
                // service_level: 4,
                declared_value: 0
              },
              flags: orderData.fragile ? [4] : [],
              packages: [
                {
                  package_size: 2,
                  description: '',
                  fragile: false
                }
              ],
              products: productsFromSkuQuantity.map(item => ({
                product: item.sku,
                flags: [],
                quantity: item.quantity,
                fulfillment_center: 1
              })),
              customer: {
                address: {
                  shipping_provider_metadata: {
                    shipblu: {
                      order: {
                        zone: {
                          // id: orderData.customer.address.zone ? orderData.customer.address.zone.id : ''
                          id: 284
                        }
                      }
                    }
                  },
                  line_1: orderData.customer.address.line_1,
                  line_2: orderData.line_2 === '' ? '.' : orderData.line_2
                },
                full_name: orderData.customer.full_name,
                phone: orderData.customer.phone,
                secondary_phone: orderData.secondary_phone ? String(orderData.secondary_phone) : null
              }
            }
          } else {
            this.syncBuyAndTryProductColumns(orderData)
            const isTryAndBuyOrder = this.isTryAndBuyOrder(orderData)
            if (isTryAndBuyOrder) orderData.cash_amount = 0
            orderBody = {
              customer: {
                full_name: orderData.customer.full_name,
                phone: orderData.customer.phone,
                secondary_phone: orderData.secondary_phone ? String(orderData.secondary_phone) : null,
                address: {
                  auto_zoned: orderData.customer.address.auto_zoned,
                  line_1: orderData.customer.address.line_1,
                  line_2: orderData.line_2 === '' ? '.' : orderData.line_2,
                  // zone: orderData.customer.address.zone ? orderData.customer.address.zone.id : ''
                  zone: 284
                }
              },
              is_customer_allowed_to_open_packages: orderData.is_customer_allowed_to_open_packages ? orderData.is_customer_allowed_to_open_packages : false,
              cash_amount: Number(isTryAndBuyOrder ? 0 : orderData.cash_amount),
              merchant_order_reference: orderData.merchant_order_reference ? orderData.merchant_order_reference : '',
              packages: [],
              order_notes: orderData.order_notes === null ? '' : orderData.order_notes,
              is_counter_dropoff: orderData.is_counter_dropoff ? orderData.is_counter_dropoff : false,
              declared_value: orderData.declared_value === '' ? 0 : Number(orderData.declared_value), 
              discount_code: orderData.discount_code,
              number_of_packages: orderData.number_of_packages === '' ? 1 : orderData.number_of_packages,
              dba: orderData.dba ? orderData.dba : ''
            }
            if (orderData.pickup_point) {
              orderBody.pickup_point = orderData.pickup_point ? orderData.pickup_point.id : null
            }
            if (!orderData.type || orderData.type === 'Delivery') {
              const buyAndTryProducts = this.getBuyAndTryProducts(orderData)
              orderBody.buy_and_try = {}
              if (buyAndTryProducts.length) {
                const shippingFees = Number(orderData.shipping_fees)
                orderBody.buy_and_try = {
                  items: buyAndTryProducts,
                  ...(Number.isFinite(shippingFees) && orderData.shipping_fees !== '' ? { shipping_fees: shippingFees } : {})
                }
              }
            }
            if (orderData.type === 'Cash Collection') {
              orderBody.amount = Number(orderData.cash_amount)
            } else {
              for (let index = 0; index < Number(orderBody.number_of_packages); index++) {
                orderBody.packages.push({
                  description: '',
                  fragile: orderData.fragile,
                  package_size: 1
                })
              }
            }
          }
          
          if (orderData.type !== 'Exchange') {
            sendRequest(true, false, this, this.fulfillment ? 'api/v1/fc/orders/outbound/' : `api/v1/${orderData.type ? this.typesDic[orderData.type] : 'delivery-orders'}/?ref=frontend-excel-sheet${orderBody?.buy_and_try?.items?.length > 0 ? '&ref_try_and_buy=true' : ''}`, 'post', orderBody, true,
              (response) => {
                this.AWBIds.push(response.data.tracking_number)
                orderData.loadRow = false
                resolve({
                  status: 200
                })
              },
              (error) => {
                orderData.loadRow = false
                common.notifyResponseError(this, error)
                reject({
                  status: 400,
                  error: error?.response?.data || { message: error?.message || 'Unexpected error' }
                })
              }
            )
          } else {
            sendRequest(true, false, this, 'api/v2/exchanges/?ref=frontend-excel-sheet', 'post', orderBody, true,
              () => {
                orderData.loadRow = false
                resolve({
                  status: 200
                })
              }, (error) => {
                orderData.loadRow = false
                reject({
                  status: 400,
                  error: error?.response?.data || { message: error?.message || 'Unexpected error' }
                })
                this.$vs.loading.close()
              })
          }
        } catch (error) {
          orderData.loadRow = false
          reject({
            status: 400,
            error: {}
          })
        }
      })
    }
  },
  components: {
    vSelect
  },
  created () {
    const merchantData = common.checkMerchantInLocalStorage(this)
    let user = {}
    merchantData.then(results => {
      user = results.merchantData
      this.subscriptionId = typeof user.subscription === 'object' ? user.subscription.id : user.subscription
    })
  }
}
</script>

<style lang="scss">
.upload-order-zone {
  text-align: left;
  .input-container {
    border: none !important;
    &:has(input:focus) {
      border: none !important;
      outline: none !important;
    }
    label {
      display: none !important;
    }
  }
}
.switch-icon {
  position: relative;
  cursor: pointer;
  span:nth-child(2) {
    display: none;
    position: absolute !important;
    top: 8.5px;
    left: 8.5px;
  }
  &:hover {
    border-radius: 6px;
    background: rgba(226, 127, 131, 0.26) !important;
    span:nth-child(1) {
      display: none;
    }
    span:nth-child(2) {
      display: block;
    }
  }
}
.animated-input {
  height: 35px;
  background: rgba(231, 231, 231, 0.81) !important;
  backdrop-filter: blur(7.5px);
  border-radius: 6px;
  padding: 6px;
}
@mixin background-gradient {
  background-image: linear-gradient(45deg, #0A326630 0px, rgba(229, 229, 229, 0.8) 40px, #0A326630 80px);
}
.line{
  margin-top: 4px;
  @include background-gradient;
  animation: shine-lines 1s infinite alternate;
}
@keyframes shine-lines {
  0% {background-position: 200px;}
  100% {background-position: -200px;}
}
</style>
